<template>
    <div class="OrderDetails">
        <Header></Header>
        <div style="width: 1000px;overflow: hidden;overflow-y: auto;scrollbar-width: none; " :style="{
            'margin-left': innerWidth > 1000 ? (innerWidth - 1000) / 2 + 'px' : '0px',
            'height': (innerHeight - 70 - 68) + 'px'
        }">

            <div class="wrap">
                <div class="content_wrap">
                    <div class="fee_wrap"><span style="font-size: 18px;font-weight: 600;">支付金额</span>
                        <span style="font-size: 18px;font-weight: 600;color: #f2460c;">￥</span>
                        <span style="font-size: 29px;font-weight: 600;color: #f2460c;">{{
                            (orderInfo.price / 100).toFixed(2) }}</span>
                    </div>
                    <div class="rest_time">
                        <div v-if="orderInfo.orderState == 0">订单已取消</div>
                        <div v-if="orderInfo.orderState == 1">订单待支付</div>
                        <div v-if="orderInfo.orderState == 4">订单已完成</div>
                    </div>
                    <div class="pay_type">
                        <div class="pay_title">选择支付方式：</div>
                        <div style="text-align: left;margin-top: 20px;">
                            <div style="height: 40px;">
                                <el-radio v-model="payType" label="wx">
                                    <img src="../../../static/image/wx.png" style="width: 25px;vertical-align: middle">
                                    <span style="vertical-align: middle;margin-left: 10px;">微信支付</span>
                                </el-radio>
                            </div>
                            <div style="line-height: 40px;">
                                <el-radio v-model="payType" label="zfb">
                                    <img src="../../../static/image/zfb.png" style="width: 25px;vertical-align: middle">
                                    <span style="vertical-align: middle;margin-left: 10px;">支付宝支付</span>
                                </el-radio>
                            </div>
                        </div>
                    </div>
                    <div v-if="showWxQr" class="tc">
                        <div><img :src="qrUrl" class="wx_qr_code" style="width: 150px;"></div>
                        <img src="../../../static/image/wx_tips.jpg" style="width: 200px;;clear: both;">
                    </div>
                </div>
                <div class="tc " v-if="orderInfo.orderState == 1" style="margin-top: 40px;">
                    <el-button style="width: 200px;" type="danger" @click="goPay">立即支付</el-button>
                </div>
            </div>
        </div>
        <Suspension></Suspension>
        <Footer></Footer>

    </div>



</template>


<script>
import Header from "../../components/common/Header"
import Footer from "../../components/common/Footer"
import Suspension from "../../components/common/Suspension"

import {
    getByParam,
    sendPostRqeByJSON
} from '@/api/api.js';


import {
    // getLocalStorage
} from '@/utils/util.js';



export default {
    name: "OrderDetails",
    components: {
        Header,
        Footer,
        Suspension
    },
    data() {
        return {
            payType: 'wx',
            showWxQr: false,
            orderInfo: {},
            qrUrl: '',
            chooseAddress: {},
            innerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            innerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
        }
    },

    mounted() {
        this.ordersId = this.$route.query.ordersId;
        this.getOrderDetails();

    },
    methods: {
        getOrderDetails() {
            let param = {
                ordersId: this.ordersId
            }
            getByParam('/web/orders/payInfo', param).then(res => {
                console.log('detail', res)
                this.orderInfo = res.data;
                if (this.orderInfo.orderState != 1) {
                    clearInterval();
                }
            })
        },
        goPay() {
            if (this.orderInfo.orderState == 0 || this.orderInfo.orderState == 4) {
                this.$message({
                    message: "订单已无法进行支付",
                    type: 'error',
                    duration: 1000
                });
                return
            }
            if (this.payType == 'wx') {
                sendPostRqeByJSON({ 'ordersId': this.ordersId }, '/web/orders/pay').then(res => {
                    console.log(res)
                    this.showWxQr = true
                    this.qrUrl = res.data.qrCodeImage
                })
                setInterval(() => {
                this.getOrderDetails();
            }, 5000)
            }else if (this.payType == 'zfb') {
                sendPostRqeByJSON({ 'ordersId': this.ordersId }, '/web/orders/pay/alipay').then(res => {
                    console.log(res)
                    window.open(res.data.payPageUrl)
                })
            }
        }
    },
}
</script>
<style scoped>
.wrap {
    padding-top: 30px;
}

.content_wrap {
    position: relative;
    width: 1000px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(30, 109, 148, .0392156862745098);
    margin: 0 auto;
    padding: 20px 0;
    text-align: center;
}

.fee_wrap {
    color: #2b2e33;
}

.rest_time {
    font-size: 14px;
    margin-top: 20px;
    color: #2b2e33;
}

.pay_type {
    margin-top: 60px;
    font-size: 0;
    padding: 0 80px;
}

.pay_title {
    text-align: left;
    color: #2b2e33;
    font-size: 16px;
    line-height: 20px;
}

.wx_qr_code {
    border: 1px solid #ddd;
    box-shadow: 5px 5px 0 rgba(0, 0, 0, .04);
    width: 150px;
    height: 150px;
    padding: 10px;
    margin: 30px auto 10px;
}
</style>